<template>
  <div class="navbar-item has-dropdown is-hoverable">
    <i
      v-if="seen.length>0 && !queue[0].is_default"
      class="has-text-centered alerts-indicator"
    >{{seen.length}}</i>

    <a class="navbar-item navbar-link is-arrowless">
      <span class="icon">
        <font-awesome-icon class="folder" :icon="'bell'" />
      </span>
    </a>

    <div
      @mouseleave="$store.dispatch('notifications/sendRead',seenId)"
      class="navbar-dropdown alerts-dropdown"
    >
      <div v-for="item in queue" :key="item.id" class="navbar-item">
        <a :class="{'is-seen':item.is_seen}" :href="item.url">{{item.message}}</a>
        <a>
          <span v-if="!item.is_default" title="Mark as read" v-tippy class="icon">
            <font-awesome-icon
              @click="$store.dispatch('notifications/markRead',item.id)"
              class="folder"
              :icon="'minus-circle'"
            />
          </span>
        </a>
      </div>
      <div v-if="!queue[0].is_default" class="navbar-item">
        <a @click="$store.dispatch('notifications/markAllRead',queue)">Mark all as read</a>
      </div>
      <!-- <button @click="$store.dispatch('notifications/sendRead')" class="button">confirm</button> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Alerts",
  data: function() {
    return {
      defaultItem: {
        id: 1,
        message: "No alerts",
        url: ""
      }
    };
  },
  computed: {
    ...mapState({
      queue(state) {
        let queue = state.notifications.queue.filter(notification => {
          return notification.is_read == false;
        });
        if (queue.length > 0) {
          return queue;
        } else {
          return [
            {
              id: 1,
              message: "No alerts",
              url: null,
              is_default: true
            }
          ];
        }
      }
    }),
    seen() {
      return this.queue.filter(notification => {
        return notification.is_seen == false;
      });
    },
    seenId() {
      let ids = [];
      this.seen.forEach(element => {
        ids.push(element.id);
      });
      return ids;
    }
  },

  methods: {
    withinFiveDays(date) {
      let now = this.$moment();
      let subject = this.$moment(new Date(date));

      let diffInDays = subject.diff(now, "days");

      if (diffInDays < -5) {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {
    this.$store.dispatch("notifications/getNotifications");
  }
};
</script>


<style lang="scss">
@import "@/assets/scss/variables.scss";

.alerts-dropdown {
  text-transform: initial;
}

.alerts-indicator {
  color: white;
  font-size: small;
  position: absolute;
  right: 0;
  font-style: inherit;
  background-color: red;
  border-radius: 17%;
  width: 1rem;
  height: fit-content;
  z-index: 1;
}

.is-seen {
  color: $lightBlue !important;
}
</style>
